// extracted by mini-css-extract-plugin
export default {"moviesGrid":"moviesGrid_moviesGrid__wA6M4","movieGrid":"moviesGrid_movieGrid__LNg9Q"};